<template>
  <div class="info-box-premie">
    <p
      class="info-box-premie__text info-box-premie__text--yes"
      v-if="text.has"
    >
      {{ this.text.yes }}
    </p>
    <p
      class="info-box-premie__text info-box-premie__text--no"
      v-else
    >
     {{ this.text.no }}
    </p>

    <div class="info-box-premie__box" v-if="!text.has">
      <h6 class="info-box-premie__box-title"> {{ this.text.info.title }} </h6>
      <p> {{ this.text.info.text }} </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBoxPremiebefrielse',
  props: [ 'text' ],
}
</script>

<style lang="scss" scoped>
.info-box-premie {
  margin-bottom: 3rem;
  &__text {
    margin: 2rem 0;

    &--no {
      color: $red;
    }

    &--yes {
      color: $green;
    }
  }

  &__box {
    background-color: $light;
    padding: 3rem;
    border-radius: $borderRadius;
  }
}
</style>
